import { Injectable, NgZone } from '@angular/core';
import Upscope, { CobrowsingSdkConfiguration, Instruction } from '@upscopeio/sdk';

import { FeatureToggleService } from './feature-toggle.service';

type _UpscopeIdent = Pick<CobrowsingSdkConfiguration, 'uniqueId' | 'identities'>;

@Injectable({
  providedIn: 'root',
})
export class UpscopeService {
  #didInit :boolean = false;

  constructor(
    private _ngZone :NgZone,
    private _feature :FeatureToggleService,
  ) {}

  init() {
    if (
      !this._feature.isActive('utah_UTAH-154_helloscreen_by_upscope') ||
      this.#didInit
    ) {
      return;
    }

    this.#didInit = true; // set up-front so we don't end up in infinite loop
    this.#upscopeOutsideAngular('init', {
      apiKey: 'kFsFeVJ7je',
    });
  }

  identify(ident :_UpscopeIdent) {
    this.#upscopeOutsideAngular('updateConnection', ident);
  }

  #upscopeOutsideAngular(...instruction :Instruction) {
    if (!this._feature.isActive('utah_UTAH-154_helloscreen_by_upscope')) {
      return;
    }
    if (!this.#didInit) {
      this.init();
    }

    this._ngZone.runOutsideAngular(() => {
      Upscope(...instruction);
    });
  }
}
